export default "__VITE_ASSET__COtXKijO__"